const categories = [
  "Жіноче здоров'я",
  "Жінки в політиці",
  "Жінки науковиці та культурні діячки",
  "Материнство",
  "Рівні права і можливості",
];

export { categories };
